import { render, staticRenderFns } from "./small-screen-owner-menu.vue?vue&type=template&id=4f203461&scoped=true"
import script from "./small-screen-owner-menu.vue?vue&type=script&lang=js"
export * from "./small-screen-owner-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f203461",
  null
  
)

export default component.exports